import moment from 'moment-timezone';

import { getUserTimezone } from '@commons/utils/date';
import { TIME_DISPLAY_FORMATS } from '@commons/DatePickers/constants';

/**
 * Whether the channel belongs to the header of an order. Central kitchens do not distinguish
 * channels — their products carry a single price — so the field is hidden for them, exactly as it is
 * on a mono-channel platform.
 *
 * @param {Object} params
 * @param {boolean} params.hasMultipleChannels - Whether the platform serves several channels
 * @param {Object|null} params.store - The store of the order, its `isKitchen` driving the result
 *
 * @returns {boolean}
 */
export const isChannelFieldDisplayed = ({ hasMultipleChannels, store }) =>
  hasMultipleChannels && !store?.isKitchen;

/**
 * Delivery date of a saved order as the date picker reads it.
 *
 * @param {string|null} deliveryDate - The delivery date carried by the order
 *
 * @returns {Object|null} A moment, or null when the order carries no date
 */
export const parseDeliveryDate = (deliveryDate) => {
  if (!deliveryDate) {
    return null;
  }

  return moment(deliveryDate);
};

/**
 * Delivery time of a saved order as the time picker reads it. The order carries a plain `HH:mm`,
 * which only means anything against a timezone — the user one, the picker displaying it as typed.
 *
 * @param {string|null} deliveryTime - The delivery time carried by the order
 *
 * @returns {Object|null} A moment, or null when the order carries no time
 */
export const parseDeliveryTime = (deliveryTime) => {
  if (!deliveryTime) {
    return null;
  }

  return moment.tz(deliveryTime, TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE, getUserTimezone());
};
